import { motion } from 'framer-motion'

import Image from 'next/image'

export const Box = ({ src }) => {
    return (
        <motion.div
            initial={{ scale: 0.5, y: 100, opacity: 0 }}
            whileInView={{ scale: 1, y: 0, opacity: 1 }}
            // viewport={{ once: true }}
            transition={{ type: "spring", bounce: 0.25 }}
        >
            <Image src={src} layout={`responsive`} width={240} height={263} />
        </motion.div>
    )
}